import z from 'zod';

export const donationSchema = z.object({
  donationAmount: z.number().min(1).nonnegative('Contribution amount must be positive'),
  donationCurrency: z.string(),
  donationType: z.string(),
  paymentMethod: z.enum(['debit_credit', 'manual_payment']),
});
